<template>
  <v-container fluid>
    <!-- Page Header -->
    <v-row class="mt-n6" align="center" justify="center">
      <v-col cols="12" md="auto">
        <div class="d-flex align-center justify-center">
          <v-avatar color="primary" size="52" class="mr-3 elevation-2">
            <v-icon color="white" size="28">mdi-package-variant-closed</v-icon>
          </v-avatar>
          <div>
            <div class="text-h5 font-weight-bold grey--text text--darken-2">Recepción de Órdenes</div>
            <div class="text-caption grey--text">Consulta las recepciones de órdenes de compra y su estado de facturación</div>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Filters -->
    <v-row class="my-0 py-0" justify="center">
      <v-col cols="12">
        <search-header-po @dataFilters="changeBusiness($event)" />
      </v-col>
    </v-row>

    <!-- KPI Cards -->
    <v-row class="mb-4 pt-0 mt-0" v-if="orders.length > 0">
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="rounded-xl pa-4">
          <div class="d-flex align-center">
            <v-avatar color="blue lighten-5" size="44" class="mr-3">
              <v-icon color="primary">mdi-package-variant-closed</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption grey--text text-uppercase font-weight-medium">Total</div>
              <div class="text-h5 font-weight-bold primary--text">{{ kpiStats.total }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="rounded-xl pa-4">
          <div class="d-flex align-center">
            <v-avatar color="orange lighten-5" size="44" class="mr-3">
              <v-icon color="warning">mdi-clock-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption grey--text text-uppercase font-weight-medium">Pendientes</div>
              <div class="text-h5 font-weight-bold warning--text">{{ kpiStats.pending }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="rounded-xl pa-4">
          <div class="d-flex align-center">
            <v-avatar color="green lighten-5" size="44" class="mr-3">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption grey--text text-uppercase font-weight-medium">Facturadas</div>
              <div class="text-h5 font-weight-bold success--text">{{ kpiStats.invoiced }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="rounded-xl pa-4">
          <div class="d-flex align-center">
            <v-avatar color="red lighten-5" size="44" class="mr-3">
              <v-icon color="error">mdi-file-remove-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption grey--text text-uppercase font-weight-medium">Sin Facturar</div>
              <div class="text-h5 font-weight-bold error--text">{{ kpiStats.notInvoiced }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main table card -->
    <v-card outlined class="rounded-xl">
      <v-toolbar flat class="rounded-t-xl px-2">
        <v-chip small outlined color="grey darken-1" class="mr-3">
          <v-icon left small>mdi-format-list-bulleted</v-icon>
          {{ totalItems }} registros
        </v-chip>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="Buscar..." outlined dense hide-details
          clearable style="max-width: 240px" class="mr-3" @keyup.enter="fetchData" @click:clear="fetchData"></v-text-field>
        <v-select v-model="statusType" :items="status" label="Tipo" outlined dense hide-details
          @change="change_status()" style="max-width: 180px"></v-select>
      </v-toolbar>
      <v-divider></v-divider>

      <v-data-table :search="search" :headers="headers" :items="entrys_computed" :loading="loading"
        loading-text="Cargando recepciones..." class="elevation-0" item-key="entry_order_key"
        :server-items-length="totalItems"
        :options.sync="options"
        @update:options="fetchData"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 50, 100],
          'items-per-page-text': 'Registros por página:',
          'page-text': '{0}-{1} de {2}',
          'show-first-last-page': true,
          'first-icon': 'mdi-chevron-double-left',
          'last-icon': 'mdi-chevron-double-right'
        }">
        
        <template v-slot:progress>
          <v-progress-linear indeterminate color="primary" height="4"></v-progress-linear>
        </template>
        <template v-slot:[`item.entry_id`]="{ item }">
          <span v-if="item.entry_id != null" class="rec-link primary--text font-weight-bold"
            @click="viewReception(item.order_id, item.entry_id, true)">
            {{ filLeft(item.entry_id.toString(), 12, "0") }}
          </span>
          <v-chip v-else x-small color="warning" outlined>Pendiente</v-chip>
        </template>

        <template v-slot:[`item.order_id`]="{ item }">
          <span class="rec-link primary--text font-weight-bold" @click="showOrder(item.order_id, false, 2)">
            {{ filLeft(item.order_id.toString(), 12, "0") }}
          </span>
        </template>

        <template v-slot:[`item.entity_name`]="{ item }">
          <span class="rec-link" @click="viewEntity(item.entity_id)">{{ item.entity_name }}</span>
        </template>

        <template v-slot:[`item.invoice_number`]="{ item }">
          <span v-if="item.invoice_id != null" class="rec-link primary--text font-weight-bold"
            @click="showInvoice(item.invoice_id, true)">
            {{ item.invoice_number }}
          </span>
          <v-chip v-else x-small color="error" outlined>Sin facturar</v-chip>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip outlined small :color="time_line_orders(item.last_status_id).color">
            {{ item.last_status_name }}
          </v-chip>
        </template>

        <template v-slot:no-data>
          <div class="text-center py-12">
            <v-icon size="72" color="grey lighten-1">mdi-package-variant-closed</v-icon>
            <div class="text-h6 grey--text mt-3">Sin recepciones para mostrar</div>
            <div class="text-body-2 grey--text mt-1">Selecciona un período y unidad de negocio para consultar las
              recepciones</div>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import Filters from "../../components/FilterBussinesLocations";
import HeaderFilters from "@/components/Shop/HeaderFilters.vue";
import Order from "../../components/Shop/Order.vue";
import searchHeaderUrl, { queryInt } from "@/mixins/searchHeaderUrl";

// Estado de la pantalla que se refleja en la URL (copiar/pegar o refrescar lleva al mismo lugar):
// encabezado (ver mixins/searchHeaderUrl.js) + ?type=&search=&page=&limit=
const DEFAULT_ITEMS_PER_PAGE = 10;
const ITEMS_PER_PAGE_OPTIONS = [10, 20, 30, 50, 100];
const STATUS_TYPES = [1, 2, 3];

export default {
  components: { Order, HeaderFilters },
  mixins: [searchHeaderUrl],
  data: (vm) => ({
    search: vm.$route.query.search || "",
    options: {
      page: queryInt(vm.$route.query.page, 1) || 1,
      itemsPerPage: ITEMS_PER_PAGE_OPTIONS.includes(queryInt(vm.$route.query.limit, null))
        ? queryInt(vm.$route.query.limit, null)
        : DEFAULT_ITEMS_PER_PAGE,
    },
    totalItems: 0,
    fetchToken: 0,
    kpiStatsData: { total: 0, invoiced: 0, notInvoiced: 0, pending: 0 },
    loading: false,
    dialog: false,
    dialogDelete: false,
    suplidor: false,
    cliente: false,
    disabledName: false,
    plazoPagoSuplidor: null,
    plazoPagoCliente: null,
    documents: [],
    rncValid: false,
    selectedStatus: "",
    accounts: [],
    order_status: [],
    orders: [],
    statusType: STATUS_TYPES.includes(queryInt(vm.$route.query.type, null)) ? queryInt(vm.$route.query.type, null) : 1,
    status: [{ value: 1, text: "PENDIENTES" }, { value: 2, text: 'FACTURADAS' }, { value: 3, text: "SIN FACTURAR" }],
    cxc: "",
    cxp: "",
    selectedDocument: "",
    selectedtypesNcfCliente: "",
    selectedtypesNcfSuplidor: "",
    selectedProvincies: "",
    last_filters: null,
    headers: [
      { text: "Entrada", align: "start", value: "entry_id" },
      { text: "Orden", align: "start", value: "order_id" },
      { text: "Factura", value: "invoice_number" },
      { text: "Unidad negocio", value: "business_unit_description_long" },
      { text: "Sucursal", value: "location_description_long" },
      { text: "Fecha", value: "formatted_date" },
      { text: "Suplidor", value: "entity_name" },
      { text: "Monto", value: "amount", align: "end" },
      { text: "Estatus", value: "status" },
      // { text: "Total", value: "total_amount", align: "end" },
      // { text: "Status", value: "sta_description" },

      //{ text: "Actions", value: "actions", sortable: false },
    ],

    editedIndex: -1,
    editedItem: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva orden" : "Editar orden";
    },
    entrys_computed() {
      return this.orders.map((element, idx) => ({
        ...element,
        entry_order_key: `${element.entry_id ?? 'e'}-${element.order_id}-${idx}`,
      }));
    },
    kpiStats() {
      return this.kpiStatsData;
    },
  },

  watch: {},

  created() {
    // Debe ir antes de que se cree SearchHeaderPO: el encabezado lee sus valores del store
    this.applyUrlToHeader();
    this.initialize();
  },

  methods: {
    change_status() {
      this.options.page = 1;
      this.fetchData();
    },
    changeBusiness(item) {
      // La primera emisión del encabezado es la carga inicial: respeta ?page= de la URL
      const firstLoad = !this.last_filters;
      // El encabezado emite en `location` la lista de sucursales cuando es "Todas";
      // aquí se manda solo el id elegido (0 = todas) y el servidor resuelve el acceso.
      const location = this.$store.state.app.filters.location;
      const locationId = location !== null && typeof location === "object" ? location.value : location;
      this.last_filters = {
        business: item.business || 0,
        location: locationId || 0,
        dateStart: item.dateStart,
        dateEnd: item.dateEnd,
      };
      if (!firstLoad && this.options.page !== 1) {
        // El cambio de página dispara update:options -> fetchData
        this.options = { ...this.options, page: 1 };
        return;
      }
      this.fetchData();
    },
    // Filtros que se envían al servidor (sin paginación)
    requestFilters() {
      return { ...this.last_filters, search: this.search || "" };
    },
    async fetchKpis() {
      try {
        const res = await this.api_Post("shopping/receptions_kpis", this.requestFilters());
        if (res.status == 200) {
          this.kpiStatsData = await res.json();
        }
      } catch (e) {
        console.error(e);
      }
    },
    syncUrl() {
      const query = this.headerUrlQuery();
      if (this.statusType !== 1) query.type = String(this.statusType);
      if (this.search) query.search = this.search;
      if (this.options.page > 1) query.page = String(this.options.page);
      if (this.options.itemsPerPage !== DEFAULT_ITEMS_PER_PAGE) query.limit = String(this.options.itemsPerPage);
      this.replaceUrlQuery(query);
    },
    async fetchData() {
      if (!this.last_filters) return;
      this.syncUrl();
      this.fetchKpis();
      const token = ++this.fetchToken;
      try {
        this.loading = true;

        const payload = {
          ...this.requestFilters(),
          page: this.options.page || 1,
          limit: this.options.itemsPerPage || DEFAULT_ITEMS_PER_PAGE,
        };
        let endpoint = "shopping/receptions_pending_paginated";
        if (this.statusType !== 1) {
          endpoint = "shopping/receptions_paginated";
          payload.invoiced = this.statusType === 2;
        }

        const responseRequest = await this.api_Post(endpoint, payload);
        const result = await responseRequest.json();
        if (token !== this.fetchToken) return;

        if (responseRequest.status !== 200) {
          this.$toast.warning(result.message || "No se pudieron cargar las recepciones");
          this.orders = [];
          this.totalItems = 0;
          return;
        }

        this.orders = result.data || [];
        this.totalItems = result.total || 0;

        for (let key in this.orders) {
          const details = this.statusType !== 1 ? this.orders[key].order_item_entries : this.orders[key].order_details;
          if (!details || !Array.isArray(details)) {
            this.orders[key].amount = `${this.orders[key].currency_code || 'USD'} ${this.currencyFormat(0)}`;
            continue;
          }
          this.orders[key].amount = `${this.orders[key].currency_code || 'USD'} ${this.currencyFormat(details.reduce((acc, item) => {
            const subtotal = (item.quantity * (item.price - (item.price * (item.discount || 0))));
            return acc + subtotal;
          }, 0))}`;
        }
      } catch (error) {
        if (token === this.fetchToken) this.$toast.error(error.message);
      } finally {
        if (token === this.fetchToken) this.loading = false;
      }
    },
    async initialize() {
      let result_orders = await this.api_Get("shopping/order_status");
      this.order_status = await result_orders.json();
      this.order_status.unshift({ id: 0, name: "Todos" });
      this.selectedStatus = this.order_status[0].id;
    },

    editItem(item) {
      this.editedIndex = this.entitys.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.entitys.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.entitys.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style scoped>
.rec-link {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 3px;
  transition: opacity 0.15s;
}

.rec-link:hover {
  opacity: 0.65;
}
</style>